import { HeroSecondary } from "../headers/HeroSecondary";
import { SectionGridTwoColumns } from "../sections/grids/SectionGridTwoColumns";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { SectionBlockTextColumns } from "../sections/blocks/SectionBlockTextColumns";
import { SectionBlockMediaCalloutCard } from "../sections/blocks/SectionBlockMediaCalloutCard";
import { HeroPrimary } from "../headers/HeroPrimary";
import { SectionBlockMediaFeatured } from "../sections/blocks/SectionBlockMediaFeatured";
import { SectionBlockCallout } from "../sections/blocks/SectionBlockCallout";
import { SectionBlockStatsAlt } from "../sections/blocks/SectionBlockStatsAlt";
import { SectionBlockMediaItem } from "../sections/blocks/SectionBlockMediaItem";
import { SectionCardCarousel } from "../sections/blocks/SectionCardCarousel";
import { CardCarousel } from "../components/cards/CardCarousel";

export interface ITemplateResearch {
  data: any;
}

export default function TemplateResearch({ data }: ITemplateResearch) {
  const {
    heroPrimary,
    sectionBlockTextColumns,
    sectionBlockStatsAlt,
    callToAction,
    featuredImage,
    sectionBlockCallout,
    sectionBlockCardCarousel,
  } = data;

  return (
    <>
      {heroPrimary && <HeroPrimary data={heroPrimary} />}
      <WrapperComponents>
        {sectionBlockTextColumns && (
          <SectionBlockTextColumns data={sectionBlockTextColumns} />
        )}
        {sectionBlockStatsAlt && (
          <SectionBlockStatsAlt data={sectionBlockStatsAlt} />
        )}

        {sectionBlockCardCarousel && sectionBlockCardCarousel.items &&
          sectionBlockCardCarousel.items.length > 0 && (
            <SectionCardCarousel
              theme="light"
              data={{
                text: sectionBlockCardCarousel.text,
                title: sectionBlockCardCarousel.title,
                link: sectionBlockCardCarousel.link,
              }}
            >
              {Array.isArray(sectionBlockCardCarousel.items) &&
                sectionBlockCardCarousel.items.map(
                  (item: any, index: number) => (
                    <CardCarousel
                      heightFull
                      // truncateLength={60}
                      theme="colour"
                      fontSize="xs"
                      card={{
                        title: item.title,
                        text: item.text,
                        ...(item.link && item.link.text && (item.link.url || item.link.slug) ? { link: item.link } : {}),
                      }}
                      key={index}
                      index={index + 1}
                    />
                  ),
                )}
            </SectionCardCarousel>
          )}

        {callToAction && <SectionBlockMediaItem data={callToAction} />}
        {featuredImage && (
          <SectionBlockMediaFeatured
            data={{
              image: featuredImage,
            }}
          />
        )}
        {sectionBlockCallout && (
          <SectionBlockCallout data={sectionBlockCallout} theme="colour" />
        )}
      </WrapperComponents>
    </>
  );
}
